import React, { Fragment } from 'react';
import cx from 'classnames';
import { times } from 'lodash-es';

import Skeleton from '../../../../Skeleton';

export default {
  widgetPerformance: (
    <Fragment>
      <div className="widget-body__description">
        <Skeleton height={20} />
      </div>
      <Skeleton height={32} />
    </Fragment>
  ),
  widgetRanks: (
    <div className="widget-body">
      <div className="widget-body__table-body">
        <div className="store-rank">
          {times(3).map((n) => (
            <div key={n} className={cx('widget-body__table-body-item')}>
              <Skeleton height={12} />
            </div>
          ))}
        </div>
      </div>
    </div>
  ),
  performanceChart: (
    <Fragment>
      <div className="performance-section-chart-change">
        <Skeleton height={48} width={125} />
      </div>
      <div className="performance-chart">
        <Skeleton height={180} />
      </div>
    </Fragment>
  ),
  ratingsCountries: (
    <div className="rating-countries">
      {' '}
      {times(4).map((n) => (
        <Skeleton key={n} height={35} />
      ))}
    </div>
  ),
  asoScoreProgressBar: (
    <div className="score-item">
      <Skeleton height={16} width={200} />
      <div className="metrics">
        <Skeleton height={79} width={158} />
        <div className="metrics__bar">
          {times(2).map((n) => (
            <Skeleton key={n} height={24} width={210} />
          ))}
        </div>
      </div>
    </div>
  ),
};
